import styled from 'styled-components';

// Main container
export const Container = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
`;

export const Title = styled.h2`
  color: #ffffff;
  margin-bottom: 30px;
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  font-family: var(--font-family-poppins);
`;

// Tabs
export const TabsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 30px;
`;

export const TabButton = styled.button<{ $active: boolean }>`
  padding: 12px 32px;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: var(--font-family-poppins);
  
  background: ${props => props.$active
    ? 'linear-gradient(135deg, #6352e8 0%, #8b7aff 100%)'
    : 'rgba(255, 255, 255, 0.1)'};
  color: ${props => props.$active ? '#ffffff' : '#999999'};
  
  &:hover {
    background: ${props => props.$active
    ? 'linear-gradient(135deg, #6352e8 0%, #8b7aff 100%)'
    : 'rgba(255, 255, 255, 0.15)'};
    color: #ffffff;
    transform: translateY(-2px);
  }
  
  @media (max-width: 768px) {
    padding: 10px 24px;
    font-size: 14px;
  }
`;


// Vote list and cards
export const VotesList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
  padding-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const VoteCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(99, 82, 232, 0.3);
  }
`;

export const VoteMediaContainer = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  background: #f0f0f0;
  overflow: hidden;
`;

export const VoteImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const VoteVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const PlayIconOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: rgba(99, 82, 232, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  
  &::after {
    content: '';
    width: 0;
    height: 0;
    border-left: 20px solid white;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    margin-left: 4px;
  }
`;

export const VoteContent = styled.div`
  padding: 16px;
`;

export const VoteHeadline = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #160133;
  margin-bottom: 8px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const VoteCategory = styled.span`
  display: inline-block;
  background: linear-gradient(135deg, #6352e8 0%, #8b7aff 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  text-transform: capitalize;
  margin-bottom: 12px;
`;

export const VoteInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e0e0e0;
`;

export const VoteRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
`;

export const VoteLabel = styled.span`
  color: #666;
  font-weight: 500;
`;

export const VoteValue = styled.span<{ $color?: string }>`
  color: ${props => props.$color || '#160133'};
  font-weight: 600;
`;

export const VoteChoice = styled.div<{ $vote: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  background: ${props => {
    if (props.$vote === 'up') return 'linear-gradient(135deg, #10b981 0%, #059669 100%)';
    if (props.$vote === 'down') return 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)';
    return 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)';
  }};
  color: white;
`;

export const VoteDate = styled.div`
  font-size: 12px;
  color: #999;
  margin-top: 8px;
`;

// Modal styles
export const ModalOverlay = styled.div<{ $show: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: ${props => props.$show ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
`;

export const ModalContent = styled.div`
  background: black;
  border-radius: 1rem;
  max-width: 1200px;
  width: 50%;
  max-height: 95vh;
  height: 60vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
    
  @media (max-width: 1024px) {
    width: 60%;
    height: 60vh;
  }
  
  @media (max-width: 768px) {
    width: 95%;
    height: 65vh;    
  }
  
  @media (max-width: 480px) {
    width: 95%;
    height: 65vh;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.5rem;
  z-index: 10;
  transition: background-color 0.2s;
  
  &:hover {
    background: rgba(0, 0, 0, 0.7);
  }
`;

export const MediaSection = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  overflow: hidden;
  z-index: 1;
`;

export const MediaImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const MediaVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const MediaOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5));
  z-index: 2;
`;

export const ContentSection = styled.div`
  position: relative;
  z-index: 3;
  padding: 2rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  
  @media (max-width: 768px) {
    padding: 1.5rem;
  }
  
  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

export const ModalInfo = styled.div`
  color: white;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

// Pagination and utility components
export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  padding: 30px 0;
`;

export const PageInfo = styled.span`
  font-size: 14px;
  color: #ffffff;
  margin: 0 15px;
  font-weight: 500;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #ffffff;
  font-size: 18px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  backdrop-filter: blur(10px);
`;
